export default __webpack_public_path__ + "static/media/bezos2.ff39b6f4.png";